import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: import.meta.env.DEV ? "online" : "offlineFirst",
      staleTime: Infinity,
      retry: false,
      gcTime: 1000 * 60 * 30, // 30 minutes — inactive queries are evicted from memory (still persisted to localStorage by the async-storage persister)
      refetchOnReconnect: true,
    },
    mutations: {
      networkMode: "online", // import.meta.env.DEV ? "online" : "offlineFirst",
      gcTime: 1000 * 60 * 30, // 30 minutes
    },
    dehydrate: {
      shouldRedactErrors: () => false,
      shouldDehydrateQuery: (query) => {
        return query.meta?.persisted !== false
      },
      shouldDehydrateMutation: (mutation) => {
        // Persist mutations that are paused (waiting for network)
        // These will be rehydrated and reconnected via the mutation registry
        return mutation.state.status !== "success"
      },
    },
  },
})
